/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { MySvgControllerService } from './services/my-svg-controller.service';
import { TollServiceControllerService } from './services/toll-service-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    MySvgControllerService,
    TollServiceControllerService,
    ApiConfiguration
  ],
})
export class TollComposerModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<TollComposerModule> {
    return {
      ngModule: TollComposerModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: TollComposerModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('TollComposerModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
